import {
  awaitAnimate,
  Particle,
  ParticleModes,
} from "../../../engine/anims/Particle";
import Colors from "../../Colors";

export const MovedLetterFadeParticle = {
  mode: ParticleModes.DRAW_OVER_LAST,
  char: null,
  fg: Colors.GRAY_3,
  bg: null,
  animate: async (
    particle: Particle<{ ch: string | null; fg: string | null }>
  ) => {
    particle.char = particle.options?.ch || particle.char;
    await awaitAnimate({
      driver: particle.driver,
      from: particle.options?.fg,
      to: Colors.OFF_BLACK,
      duration: 500,
      onUpdate: (latest) => {
        particle.fg = latest;
      },
    });
  },
};
